import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch } from 'react-router';
import { Route } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';
import SubmissionsButton from '../../containers/SubmissionsButton';
import GameQuery from '../../query/GameQuery';
import { BALANCESHEET, BUSINESSPLAN, CASHFLOW, EXPORTREPORTS, INCOMESTATEMENT, PROCUREMENT, PROCUREMENTCOST, PROCUREMENTINVENTORY, PROCUREMENTOVERVIEW, PROCUREMENTSUPPLIER, PRODUCTION, PRODUCTIONEXTERNALLY, PRODUCTIONFIXEDCOSTS, PRODUCTIONINTERNALLY, PRODUCTIONPROGRAM, PRODUCTIONQUALITYCHECK, SALES, SALESPROGRAM, SALESTEST, SUBMISSIONPOPUP } from '../../routes';
import BalanceSheetRoute from '../../screens/BalanceSheetRoute';
import CashFlowStatementRoute from '../../screens/CashFlowStatementRoute';
import IncomeStatementRoute from '../../screens/IncomeStatementRoute';
import ProcurementCostsRoute from '../../screens/ProcurementCostsRoute';
import ProcurementInventoryRoute from '../../screens/ProcurementInventoryRoute';
import ProcurementOverviewRoute from '../../screens/ProcurementOverviewRoute';
import ProcurementSupplierRoute from '../../screens/ProcurementSupplierRoute';
import ProductionExternallyRoute from '../../screens/ProductionExternallyRoute';
import ProductionFixedCostsRoute from '../../screens/ProductionFixedCostsRoute';
import ProductionInternallyRoute from '../../screens/ProductionInternallyRoute';
import ProductionProgramRoute from '../../screens/ProductionProgramRoute';
import ProductionQualityCheckRoute from '../../screens/ProductionQualityCheckRoute';
import SalesProgramRoute from '../../screens/SalesProgramRoute';
import SalesTestRoute from '../../screens/SalesTestRoute';
import BusinessPlanExportLink from '../BusinessPlanExportLink';
import BusinessPlanLayout from '../BusinessPlanLayout';
import BusinessPlanLink from '../BusinessPlanLink';
import BusinessPlanModeDescription from '../BusinessPlanModeDescription';
import BusinessPlanNavBar from '../BusinessPlanNavBar';
import BusinessPlanNextButton from '../BusinessPlanNextButton';
import BusinessPlanSectionMenu from '../BusinessPlanSectionMenu';
import BusinessPlanSectionTitle from '../BusinessPlanSectionTitle';
import Compute from '../Compute';
import Divider from '../Divider';
import Icon from '../Icon';
import SubmissionPopUp from '../SubmissionPopUp';
import SubmissionStepper from '../SubmissionStepper';
import WindowOptions from '../WindowOptions';

const BusinessPlan = ({ game, history, location, match }) => {
	const currentRoute = location.pathname.substr(
		location.pathname.lastIndexOf('/') + 1
	);
	const doneLink = route => {
		const paths = [
			'sales-test',
			'sales-program',
			'sales',
			'production-program',
			'production-internally',
			'production-externally',
			'production-quality-check',
			'production-fixed-costs',
			'production',
			'procurement-overview',
			'procurement-supplier',
			'procurement-inventory',
			'procurement-costs',
			'procurement',
			'income-statement',
			'balance-sheet',
			'cash-flow',
			'export-reports'
		];
		return paths.indexOf(route) < paths.indexOf(currentRoute);
	};
	const getRoute = path =>
		formatRoute(path, {
			gameID: game.id,
			businessPlanID: match.params.businessPlanID
		});
	return (
		<BusinessPlanLayout>
			<BusinessPlanLayout.SideBar>
				<WindowOptions history={history} />
				<Icon icon="businessplanEris" />
				<GameQuery>
					<BusinessPlanModeDescription />
				</GameQuery>
				<Divider />
				<BusinessPlanLink
					to={getRoute(SALES)}
					icon="sales"
					label="sales-business-plan-link"
					activeColorClass="business-plan-link-active-orange"
					done={doneLink('sales')}
				/>
				<BusinessPlanLink
					to={getRoute(PRODUCTION)}
					icon="production"
					label="production-business-plan-link"
					activeColorClass="business-plan-link-active-orange"
					done={doneLink('production')}
				/>
				<BusinessPlanLink
					to={getRoute(PROCUREMENT)}
					icon="procurement"
					label="procurement-business-plan-link"
					activeColorClass="business-plan-link-active-orange"
					done={doneLink('procurement')}
				/>
				<Divider />
				<BusinessPlanLink
					to={getRoute(INCOMESTATEMENT)}
					icon="income"
					label="income_statement-business-plan-link"
					activeColorClass="business-plan-link-active-blue"
					disabledOpacity={true}
				/>
				<BusinessPlanLink
					to={getRoute(BALANCESHEET)}
					icon="balancesheet"
					label="balance_sheet-business-plan-link"
					activeColorClass="business-plan-link-active-blue"
					disabledOpacity={true}
				/>
				<BusinessPlanLink
					to={getRoute(CASHFLOW)}
					icon="cashflow"
					label="cash_flow-business-plan-link"
					activeColorClass="business-plan-link-active-blue"
					disabledOpacity={true}
				/>
				<BusinessPlanExportLink
					businessPlan={game.businessPlan}
					icon="exportreports"
					label="download-business-plan-link"
					activeColorClass="business-plan-link-active-blue"
					download={true}
					disabledOpacity={true}
				/>
			</BusinessPlanLayout.SideBar>
			<BusinessPlanLayout.Body>
				{(!game.businessPlan.readOnly && game.state !== 'COMPLETED') ? (
					<BusinessPlanLayout.BodyHeader location={location}>
						<BusinessPlanSectionTitle />
						<SubmissionsButton disabled={!game.leader} />
						<Compute match={match} />
						<BusinessPlanSectionMenu game={game} match={match} />
					</BusinessPlanLayout.BodyHeader>
				) : (
					<BusinessPlanLayout.BodyHeader location={location}>
						<BusinessPlanSectionTitle />
						<GameQuery>
							<SubmissionStepper />
						</GameQuery>
						<BusinessPlanSectionMenu game={game} match={match} />
					</BusinessPlanLayout.BodyHeader>
				)}
				<BusinessPlanLayout.BodyContent location={location}>
					<BusinessPlanNavBar />
					<Switch>
						<Route path={SUBMISSIONPOPUP} render={() => ''} />
						<Route path={SALESTEST} component={SalesTestRoute} />
						<Route path={SALESPROGRAM} component={SalesProgramRoute} />
						<Route
							path={PRODUCTIONPROGRAM}
							component={ProductionProgramRoute}
						/>
						<Route
							path={PRODUCTIONINTERNALLY}
							component={ProductionInternallyRoute}
						/>
						<Route
							path={PRODUCTIONEXTERNALLY}
							component={ProductionExternallyRoute}
						/>
						<Route
							path={PRODUCTIONQUALITYCHECK}
							component={ProductionQualityCheckRoute}
						/>
						<Route
							path={PRODUCTIONFIXEDCOSTS}
							component={ProductionFixedCostsRoute}
						/>
						<Route
							path={PROCUREMENTOVERVIEW}
							component={ProcurementOverviewRoute}
						/>
						<Route
							path={PROCUREMENTSUPPLIER}
							component={ProcurementSupplierRoute}
						/>
						<Route
							path={PROCUREMENTINVENTORY}
							component={ProcurementInventoryRoute}
						/>
						<Route path={PROCUREMENTCOST} component={ProcurementCostsRoute} />
						<Route path={INCOMESTATEMENT} component={IncomeStatementRoute} />
						<Route path={BALANCESHEET} component={BalanceSheetRoute} />
						<Route path={CASHFLOW} component={CashFlowStatementRoute} />
						<Route path={EXPORTREPORTS} component={() => {
							console.log('export')
							return <Redirect to={getRoute(SALESTEST)} />
						}} />
						<Route
							path={SALES}
							render={() => <Redirect to={getRoute(SALESTEST)} />}
						/>
						<Route
							path={PRODUCTION}
							render={() => <Redirect to={getRoute(PRODUCTIONPROGRAM)} />}
						/>
						<Route
							path={PROCUREMENT}
							render={() => <Redirect to={getRoute(PROCUREMENTOVERVIEW)} />}
						/>
						<Route
							path={BUSINESSPLAN}
							render={() => <Redirect to={getRoute(SALESTEST)} />}
						/>
					</Switch>
					<BusinessPlanNextButton game={game} match={match} />
				</BusinessPlanLayout.BodyContent>
			</BusinessPlanLayout.Body>
			{game.showSubmissionPopup && <SubmissionPopUp history={history} />}
		</BusinessPlanLayout>
	);
};

BusinessPlan.propTypes = {
	history: PropTypes.object
};

export default BusinessPlan;
